import React from 'react';
import { useMap } from 'react-leaflet';
import { CloseOutlined } from '@ant-design/icons';
import { useMapContext } from './MapProvider';

const DrawLegend = () => {
  const map = useMap();
  const { drawLegendVisible, setDrawLegendVisible } = useMapContext();
  if (!drawLegendVisible) return null;

  return (
    <div className='draw-legend-container'>
      <div className='draw-legend-box'>
        <button
          className='close-btn'
          onClick={() => setDrawLegendVisible(false)}
          aria-label='Close'
        >
          <CloseOutlined />
        </button>
        <span>ℹ️ Draw the area of interest</span>
      </div>
    </div>
  );
};

export default DrawLegend;
